import Clients from "../../assets/images/sidebar/client_management.svg";

const clientOrderManagementModule = {
  name: "Client & Order Management",
  key: "client_or_order_management",
  imgSrc: Clients,
  submodules: [
    {
      name: "Client & Order Management",
      key: "client_or_order_management",
      defaultExpanded: true,
      features: [
        {
          key: "employee_assignee",
          name: "Employee Assignee",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "view_the_list_of_all_clients",
              name: "View the list of All Clients",
              defaultEnabled: false,
              description: "Shows overview cards and complete client list"
            },
            {
              key: "view_the_list_of_all_orders",
              name: "View the list of All Orders",
              defaultEnabled: false,
              description: "Display all orders overview"
            },
            {
              key: "assign_to_employee_access",
              name: "Assign to Employee Access",
              defaultEnabled: false,
              description: "Assign employees to clients or orders"
            },
            {
              key: "change_edit_the_existing_asignee_access",
              name: "Change ( Edit ) the Existing Assignee Access",
              defaultEnabled: false,
              description: "Reassign or change employee on client or order"
            },
            {
              key: "view_the_client_details",
              name: "View the Client Details",
              defaultEnabled: false,
              description: "Open detailed service view for the client"
            },
            {
              key: "view_the_order_details",
              name: "View the Order Details",
              defaultEnabled: false,
              description: "Open detailed order view"
            }
          ]
        },
        {
          key: "service_details",
          name: "Service Details",
          defaultEnabled: false,
          subFeatures: [
            {
              key: "view_client_service_data",
              name: "View Client / Order Service Data",
              defaultEnabled: true,
              description: "Show full service, order and ticket details"
            },
            {
              key: "select_services_of_the_client",
              name: "Select Services (Of the Client)",
              defaultEnabled: false,
              description: "Switch between multiple services of the same client"
            },
            {
              key: "add_edit_task",
              name: "Add & Edit Task",
              defaultEnabled: false,
              description: "Create or modify tasks"
            },
            {
              key: "delete_task",
              name: "Delete Task",
              defaultEnabled: false,
              description: "Remove existing tasks"
            },
            {
              key: "add_edit_sub_task",
              name: "Add & Edit Sub Task",
              defaultEnabled: false,
              description: "Create or modify subtasks"
            },
            {
              key: "delete_sub_task",
              name: "Delete Sub Task",
              defaultEnabled: false,
              description: "Remove existing subtasks"
            },
            {
              key: "add_invoice",
              name: "Add Invoice",
              defaultEnabled: false,
              description: "Generate new invoice for a task"
            },
            {
              key: "edit_invoice",
              name: "Edit Invoice",
              defaultEnabled: false,
              description: "Modify invoice before client payment"
            },
            {
              key: "delete_invoice",
              name: "Delete Invoice",
              defaultEnabled: false,
              description: "Remove unpaid invoice"
            },
            {
              key: "view_password",
              name: "View Password",
              defaultEnabled: false,
              description: "Display service/order-related password"
            },
            {
              key: "view_notes",
              name: "View Notes",
              defaultEnabled: false,
              description: "Read service/order notes"
            },
            {
              key: "create_edit_notes",
              name: "Create & Edit Notes",
              defaultEnabled: false,
              description: "Add or modify service/order notes"
            },
            {
              key: "delete_notes",
              name: "Delete Notes",
              defaultEnabled: false,
              description: "Remove existing notes"
            },
            {
              key: "view_reminder",
              name: "View Reminder",
              defaultEnabled: false,
              description: "Show service/order reminders"
            },
            {
              key: "create_change_reminder",
              name: "Create & Change Reminder",
              defaultEnabled: false,
              description: "Set or update service/order reminders"
            },
            {
              key: "delete_reminder",
              name: "Delete Reminder",
              defaultEnabled: false,
              description: "Remove existing reminders"
            },
            {
              key: "change_task_priority",
              name: "Change Task Priority",
              defaultEnabled: false,
              description: "Set priority: High, Medium or Low"
            },
            {
              key: "change_task_status",
              name: "Change Task Status",
              defaultEnabled: false,
              description: "Update status: Active, Pending, Completed"
            },
            {
              key: "change_document_requirement_status",
              name: "Change Document Requirement Status",
              defaultEnabled: false,
              description: "Mark documents as Required or Not Required"
            },
            {
              key: "approve_reject_document",
              name: "Approve / Reject Document",
              defaultEnabled: false,
              description: "Approve or reject uploaded documents with reason"
            },
            {
              key: "respond_to_tickets",
              name: "Respond to Tickets",
              defaultEnabled: false,
              description: "Reply to customer tickets"
            },
            {
              key: "close_a_ticket",
              name: "Close a Ticket",
              defaultEnabled: false,
              description: "Close resolved tickets"
            },
            {
              key: "reopen_a_ticket",
              name: "Reopen a Ticket",
              defaultEnabled: false,
              description: "Reopen previously closed tickets"
            },
            {
              key: "upload_deliverables",
              name: "Upload Deliverables",
              defaultEnabled: false,
              description: "Upload final deliverable files"
            },
            {
              key: "delete_deliverables",
              name: "Delete Deliverables",
              defaultEnabled: false,
              description: "Remove uploaded deliverable files"
            },
            {
              key: "close_complete_activate_the_service",
              name: "Close / Complete / Activate the Service",
              defaultEnabled: false,
              description: "Mark service as Closed, Completed or Active (closed/completed become read-only)"
            },
            {
              key: "upload_sample_document",
              name: "Upload Sample Document",
              defaultEnabled: false,
              description: "Upload sample/reference documents"
            },
            {
              key: "update_file_description",
              name: "Update File Description",
              defaultEnabled: false,
              description: "Update description to files"
            },
          ]
        }
      ]
    }
  ]
};

export default clientOrderManagementModule;
